import {
  AccountStatusType,
  DocumentActionCategoryType,
  DocumentActionType,
  PaymentProvider,
  ViewType,
  accountServicePaymentRequest,
} from '@finxone-platform/shared/sys-config-types';
import { AccountStateModel } from '../state/account.state';

export class GetAccount {
  static readonly type = '[Account] GetAccount';
  constructor(
    public page = 1,
    public limit = 10,
    public status: AccountStatusType[] = [
      AccountStatusType.active,
      // add more status types, if needed...
    ],
    public searchParams?: {
      id?: string[];
      name?: string;
      currency?: string[];
      country?: string[];
    },
    public viewType: string = ViewType.LIST,
  ) {}
}

export class GetAccountDetails {
  static readonly type = '[Account] GetAccountDetails';
}

export class GetMonthlySummary {
  static readonly type = '[Account] GetMonthlySummary';
  constructor(public accountId: string) {}
}

export class UpdatePaymentGatewayConfig {
  static readonly type = '[Account] UpdatePaymentGatewayConfig';
  constructor(
    public payload: {
      payment: PaymentProvider;
      sandboxMode?: string;
      supportedCurrency: string[];
      bankProvider: string;
      checkPayeeEnabled: boolean;
      paymentRequest: accountServicePaymentRequest;
    },
  ) {}
}

export class SetLoadingStatus {
  static readonly type = '[Account] SetLoadingStatus';
  constructor(public isLoading: boolean) {}
}

export class SetAccountState {
  static readonly type = '[Account] SetAccountState';
  constructor(public state: AccountStateModel) {}
}

export class UpdateCurrentAccountId {
  static readonly type = '[Account] UpdateCurrentAccountId';
  constructor(public currentAccountId: string) {}
}

export class UpdateCurrentMultiCurrencyCode {
  static readonly type = '[Account] UpdateCurrentMultiCurrencyCode';
  constructor(public currencyCode: string) {}
}

export class ClearAccountCache {
  static readonly type = '[Account] ClearAccountCache';
}

export class CreateCurrencyAccount {
  static readonly type = '[Account] CreateCurrencyAccount';
  constructor(public currency: string) {}
}

export class CreateCurrencyAccountSuccess {
  static readonly type = '[Account] CreateCurrencyAccountSuccess';
}

export class UpdateAccountName {
  static readonly type = '[Account] UpdateAccountName';
  constructor(public accountId: string, public name: string) {}
}

export class UpdateAccountSpendingBudget {
  static readonly type = '[Account] UpdateAccountSpendingBudget';
  constructor(public accountId: string) {}
}

export class GetCurrentAccountDocumentDetails {
  static readonly type = '[Account] GetCurrentAccountDocumentDetails';
  constructor(
    public documentContext: DocumentActionType,
    public documentCategory: DocumentActionCategoryType,
    public accountId: string,
  ) {}
}
